import { Component} from '@angular/core';
import { Router } from '@angular/router';


@Component({
    selector: 'app-bpg-events',
    templateUrl: './bpg-events.component.html',
    styleUrls: ['./bpg-events.component.css']
})
export class BpgEventsComponent{

    constructor(private readonly  router: Router) { }

    list() {
        this.router.navigate(['events-list-view']);
    }
    calendar() {
        this.router.navigate(['events-calendar']);
    }
}